import { render } from "./MenuBarGroup.vue?vue&type=template&id=3ee14096&scoped=true"
import script from "./MenuBarGroup.vue?vue&type=script&lang=js"
export * from "./MenuBarGroup.vue?vue&type=script&lang=js"

import "./MenuBarGroup.vue?vue&type=style&index=0&id=3ee14096&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee14096"]])

export default __exports__